import { createSelector } from 'reselect'
import { propOr } from 'ramda'

const getEstateDocuments = state => state.estateDocuments
const getEstateFilesByFolderRaw = state => state.estateDocuments.estateFilesByFolder
const getEstateFilesByBpRaw = state => state.estateDocuments.estateFilesByBp

export const selectEstateFilesForFolder = folderId => state =>
  propOr([], folderId, getEstateFilesByFolderRaw(state))

export const selectEstateFilesForBp = bpId => state =>
  propOr([], bpId, getEstateFilesByBpRaw(state))

export const selectEstateCursor = key => state => state.estateDocuments.cursorByKey[key] ?? null

export const selectEstateHasMore = key => state => state.estateDocuments.hasMoreByKey[key] ?? false

export const selectEstateFolders = createSelector(
  getEstateDocuments,
  propOr([], 'estateFolders')
)

export const selectIsLoadingEstateFolders = createSelector(
  getEstateDocuments,
  propOr(false, 'isLoadingEstateFolders')
)

export const selectEstateOwnedFiles = createSelector(
  getEstateDocuments,
  propOr([], 'estateOwnedFiles')
)

export const selectEstateOwnedFilesMeta = createSelector(
  getEstateDocuments,
  propOr({ currentPage: 1, lastPage: 1, total: 0 }, 'estateOwnedFilesMeta')
)

export const selectEstateOwnedFilesFolderId = createSelector(
  getEstateDocuments,
  propOr(null, 'estateOwnedFilesFolderId')
)

export const selectIsLoadingEstateOwnedFiles = createSelector(
  getEstateDocuments,
  propOr(false, 'isLoadingEstateOwnedFiles')
)

export const selectIsUploadingEstateDocument = createSelector(
  getEstateDocuments,
  state => propOr(0, 'uploadingEstateDocumentCount', state) > 0
)

export const selectEstateLoadingProgress = createSelector(
  getEstateDocuments,
  propOr({}, 'loadingProgress')
)

export const selectEstateSearchResults = createSelector(
  getEstateDocuments,
  propOr([], 'searchResults')
)

export const selectEstateSearchMeta = createSelector(
  getEstateDocuments,
  propOr({ truncated: false, limit: null }, 'searchMeta')
)

export const selectIsSearchingEstateFiles = createSelector(
  getEstateDocuments,
  propOr(false, 'isSearchingEstateFiles')
)

export const selectLoadedEstateFolders = createSelector(
  getEstateDocuments,
  propOr(new Set(), 'loadedFolders')
)

export const selectLoadingEstateFolders = createSelector(
  getEstateDocuments,
  propOr(new Set(), 'loadingFolders')
)

export const selectEstateFolderUserCounts = createSelector(
  getEstateDocuments,
  propOr({}, 'folderUserCounts')
)

export const selectAllEstateFiles = createSelector(
  [getEstateFilesByFolderRaw],
  byFolder => {
    const seen = new Set()
    const out = []
    Object.values(byFolder || {}).forEach(list => {
      (list || []).forEach(file => {
        if (!file || seen.has(file.id)) return
        seen.add(file.id)
        out.push(file)
      })
    })
    return out
  }
)
